import BaseLayer from "./BaseLayer";
import {drawRectangle} from "../utils/map_utils";

class TXTY extends BaseLayer {
    id = "txty";
    label = "TXTY";
    defaultVisible = this.props.tileViewerState[this.id];

    draw = () => new Promise((resolve, reject) => {
        let {scanMeta, textColor} = this.props;
        for (let key in scanMeta) {
            if (key.endsWith("_5"))
                continue;

            let {y_fields, tile_width, tile_height, uperpixel, img_type} = this.props.slide;
            let x = parseInt(key.split('y')[0].split('x')[1]);
            let y = parseInt(key.split('y')[1].split('.' + img_type)[0].split("_")[0]);
            y = y_fields - y - 1;
            let dy = parseInt(key.split('y')[1].split('.' + img_type)[0].split("_")[1]);

            let v = scanMeta[key];
            if(!isNaN(dy) && dy > 0) return;

            // NORTH MARKERS
            let bounds = [
                [(x + 0.3) * (tile_width * uperpixel), (y - ((3/10) / 2) + 1) * (tile_height * uperpixel)],
                [(x + (1 - 0.3)) * (tile_width * uperpixel), (y - ((3/10) / 2) + 1) * (tile_height * uperpixel)],
                [(x + (1 - 0.3)) * (tile_width * uperpixel), (y + ((3/10) / 2) + 1) * (tile_height * uperpixel)],
                [(x + 0.3) * (tile_width * uperpixel), (y + ((3/10) / 2) + 1) * (tile_height * uperpixel)],
                [(x + 0.3) * (tile_width * uperpixel), (y - ((3/10) / 2) + 1) * (tile_height * uperpixel)]
            ];
            if(v["top"] !== undefined){
                if(v["top"]["ty"] === 0 || v["top"]["errMessage"] !== "") {
                    // Retry but still failed 
                    if(v["top"]["retryCount"] !== undefined && v["top"]["retryCount"] === 1) {
                        drawRectangle(bounds, this.layer.getSource(), true, 2, "#FF0000",
                            "", textColor);
                    }else{  // did not retry
                        drawRectangle(bounds, this.layer.getSource(), false, 2, "#FF0000",
                        "", textColor);
                    }
                }else{
                    // success with retry
                    if(v["top"]["retryCount"] !== undefined && v["top"]["retryCount"] === 1) {
                        drawRectangle(bounds, this.layer.getSource(), false, 2, "#008000",
                            "", textColor);
                    }
                }
            }
            // WEST MARKERS
            bounds = [
                [(x - ((3/10) / 2)) * (tile_width * uperpixel), (y + 0.3) * (tile_height * uperpixel)],
                [(x - ((3/10) / 2)) * (tile_width * uperpixel), (y + (1 - 0.3)) * (tile_height * uperpixel)],
                [(x + ((3/10) / 2)) * (tile_width * uperpixel), (y + (1 - 0.3)) * (tile_height * uperpixel)],
                [(x + ((3/10) / 2)) * (tile_width * uperpixel), (y + 0.3) * (tile_height * uperpixel)],
                [(x - ((3/10) / 2)) * (tile_width * uperpixel), (y + 0.3) * (tile_height * uperpixel)]
            ];
            if (v["left"] !== undefined) {
                if(v["left"]["tx"] === 0 || v["left"]["errMessage"] !== "") {
                    // Retry but still failed 
                    if(v["left"]["retryCount"] !== undefined && v["left"]["retryCount"] === 1) {
                        drawRectangle(bounds, this.layer.getSource(), true, 2, "#FF0000",
                            "", textColor);
                    }else{  // did not retry
                        drawRectangle(bounds, this.layer.getSource(), false, 2, "#FF0000",
                        "", textColor);
                    }
                }else{
                    // success with retry
                    if(v["left"]["retryCount"] !== undefined && v["left"]["retryCount"] === 1) {
                        drawRectangle(bounds, this.layer.getSource(), false, 2, "#008000",
                            "", textColor);
                    }
                }
            }
        }
        resolve();
    });
}

export default TXTY;
